// @flow
import React, {PureComponent} from 'react'
import {NotificationContainer} from 'modules/Common/components/Notification'
import I18n from 'I18n'
import {Link} from 'react-router-dom'
import {adminURL} from 'modules/Common/constants'
import styles from './Header.module.scss'
import LogoIcon from 'modules/Authenticate/components/svgIcons/logo.svg'
import IconProfile from './svgIcons/ic-user.svg'
import IconLeftArrow from './svgIcons/left-arrow.svg'

import {screenConstants} from '../constants'

import type {StateProps, OwnProps} from '../containers/HeaderContainer'

export type Props = StateProps & OwnProps;

const I18nLocal = I18n.admin

export class Header extends PureComponent<Props, void> {
  render() {
    let screen = screenConstants.home
    if (
      this.props.location.pathname === adminURL.home ||
      this.props.location.pathname === adminURL.companies.index ||
      this.props.location.pathname === adminURL.accountManagers.index
    ) {
      screen = screenConstants.home
    } else if (this.props.location.pathname.includes('companies')) {
      screen = screenConstants.companies
    } else if (this.props.location.pathname.includes('accountmanagers')) {
      screen = screenConstants.accountManagers
    }

    return (
      <div className={styles.header}>
        <Link className={styles.title} to={adminURL.home}>
          <LogoIcon width={130} height={70} />
        </Link>
        {screen === screenConstants.home ? (
          <div className={styles.text}>
            <IconProfile width={25} height={25} />
            {I18nLocal.leapXpertAdmin}
          </div>
        ) : null}
        {screen === screenConstants.companies ? (
          <Link to={adminURL.companies.index} className={`${styles.text} ${styles.back}`}>
            <IconLeftArrow width={20} height={20} />
            {I18nLocal.backToCompanies}
          </Link>
        ) : null}
        {screen === screenConstants.accountManagers ? (
          <Link to={adminURL.accountManagers.index} className={`${styles.text} ${styles.back}`}>
            <IconLeftArrow width={20} height={20} />
            {I18nLocal.backtoAMs}
          </Link>
        ) : null}
        <NotificationContainer />
      </div>
    )
  }
}

export default Header
